'use client';

import { useRef } from 'react';
import { useVerticalScrollCarousel } from '@/hooks/useVerticalScrollCarousel';
import { ProcessStepsCarouselMobileServer } from './server';
import type { ProcessStepsProps } from '../type';
import { useIsMobile } from '@/hooks/useIsMobile';

const INITIAL_HEIGHT = 1070;

export default function ProcessStepsCarouselMobileClient({ steps, title }: ProcessStepsProps) {
  const isMobile = useIsMobile(true);
  const containerRef = useRef<HTMLDivElement>(null);
  const stickyRef = useRef<HTMLDivElement>(null);
  const { activeIndex, progress, handleItemClick, totalHeight } = useVerticalScrollCarousel(
    containerRef,
    stickyRef,
    INITIAL_HEIGHT,
    steps.content.data.length
  );

  if (!isMobile) return null;

  return (
    <ProcessStepsCarouselMobileServer
      steps={steps}
      title={title}
      activeIndex={activeIndex}
      progress={progress}
      totalHeight={totalHeight}
      containerRef={containerRef}
      stickyRef={stickyRef}
      onItemClick={handleItemClick}
    />
  );
}
